<div class="row page-title">
  <span>{{ localizationConstants.ADMIN_PAGE_TITLE | translate }}</span>
</div>
<div class="row center bg-white bg-default-sm">
  <div class="request-user u-mt--large u-mw--500 col">
    <div class="o-grid--medium">
      <div class="c-form-group o-grid__item col-12">
        <button
          routerLink="{{ routeNameConstants.ADMIN_USERS }}"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.ADMIN_USERS | translate }}
        </button>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <button
          routerLink="{{ routeNameConstants.ADMIN_LOCALIZATION }}"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.ADMIN_LOCALIZATION | translate }}
        </button>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <button
          routerLink="{{ routeNameConstants.ADMIN_USERS_PENDING }}"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.ADMIN_PENDING_USERS | translate }}
        </button>
      </div>
      <div
        *ngIf="authService.user?.isCountryAdmin || authService.user?.isAdmin"
        class="c-form-group o-grid__item col-12">
        <button
          routerLink="{{ routeNameConstants.ADMIN_REMINDER_LIST_BASE }}"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.ADMIN_REMINDER_LIST | translate }}
        </button>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <button
          routerLink="{{ routeNameConstants.ADMIN_VISIBLE_EVENT }}"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.ADMIN_VISIBLE_EVENT | translate }}
        </button>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <button
          routerLink="{{ routeNameConstants.ADMIN_DOCUMENT_FILTER }}"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.ADMIN_DOCUMENT_FILTER | translate }}
        </button>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <button
          routerLink="{{ routeNameConstants.ADMIN_REQUESTED_SERVICE_LIST }}"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.ADMIN_REQUESTED_SERVICE_LIST | translate }}
        </button>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <button
          routerLink="{{ routeNameConstants.ADMIN_APPROVED_SERVICE_PRICE }}"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.ADMIN_APPROVED_MAX_SERVICE_PRICE | translate }}
        </button>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <button
          routerLink="{{ routeNameConstants.ADMIN_CONTACTS }}"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.ADMIN_CONTACTS | translate }}
        </button>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <button
          routerLink="{{ routeNameConstants.ADMIN_CUSTOMERS }}"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.ADMIN_CUSTOMERS | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
